import { Component, EventEmitter, Input, Output } from '@angular/core';
import FieldsConstants from 'src/app/common/fields.constants';
import { PaginationState } from 'src/app/interfaces/pagination.interface';

@Component({
  selector: 'dropdown-list-pagination',
  templateUrl: 'dropdown-list-pagination.component.html',
})
export class DropdownListPaginationComponent {
  @Input({ required: true }) public paginationState: PaginationState;
  @Input({ required: true }) public dropdownSelector: string;
  @Input({ required: true }) public isLoading: boolean;

  @Output() public loadMore: EventEmitter<PaginationState> = new EventEmitter<PaginationState>();

  private readonly RESULT_COUNT: number = FieldsConstants.PAGINABLE_SEARCH_RESULT_COUNT;

  private get isLastPage(): boolean {
    return this.paginationState.currentPage === Math.ceil(this.paginationState.totalItemsCount / this.RESULT_COUNT);
  }

  public get preventedScroll(): boolean {
    return this.isLastPage || this.isLoading;
  }

  public onScrollBottom(): void {
    this.loadMore.emit(this.paginationState);
  }
}
